"use strict";

angular.module("customer")
.controller("SectionNoOrderNotification", function(
    $scope, $state, $stateParams, gettextCatalog, FlashBag, $http, NoOrderNotificationService, ModalService,
    appConfig
) {
    $scope.token = $stateParams.token;

    function openNoOrderNotificationConfirmation(vendorName, deliveryDate) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./modals/no-order-notification.modal.html"),
            controller: "NoOrderNotificationConfirmationController",
            controllerAs: "noOrderNotificationConfirmationCtrl",
            inputs: {
                $attrs: {
                    vendorName: vendorName,
                    deliveryDate: deliveryDate,
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    $state.go('home');
                    return;
                }

                NoOrderNotificationService.submitTokenEmptyOrder(
                    $scope.token
                ).then(function() {
                    var message = gettextCatalog.getString("The no-order notification was sent.");
                    FlashBag.success(message, true);
                }).finally(function () {
                    $state.go('home');
                });
            });
        });
    }

    $http({
        method: "GET",
        url: appConfig.API_SERVER + "/catalog/customer/orders/no-order-notification/token/" + $scope.token + "/"
    }).then(function onSuccess(response) {
        openNoOrderNotificationConfirmation(
            response.data['vendor'],
            response.data['delivery_date']
        );
    }).catch(function onError() {
        var message = gettextCatalog.getString("Token either expired or an order was already submitted for this delivery date.");
        FlashBag.preformattedWarning(message, "", true);
        $state.go("home");
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/no-order-notification/no-order-notification.controller.js
// module id = 901
// module chunks = 0